import { useQuery } from '@tanstack/react-query';
import { getGroup, getGroupReportConfiguration } from 'services/groups';
import { queryKeys } from 'utils/query';

export const useGroup = (id?: string) => {
  return useQuery({
    queryKey: [queryKeys.groupData, id],
    queryFn: () => getGroup(id),
    enabled: !!id,
  });
};

export const useGroupReportConfiguration = (id?: string) => {
  return useQuery({
    queryKey: [queryKeys.groupReportConfiguration, id],
    queryFn: () => getGroupReportConfiguration(id),
    enabled: !!id,
  });
};
